import script from "./Tea.vue?vue&type=script&setup=true&lang=js"
export * from "./Tea.vue?vue&type=script&setup=true&lang=js"

import "./Tea.vue?vue&type=style&index=0&id=e22fa4fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e22fa4fc"]])

export default __exports__